<template>
  <div id="about-section" class="relative relative bg-lead">
    <div class="container container-s">
      <h2 class="text-center desktop-padding-top padding-l-top">
        {{ t("justopp.aboutSection.title") }}
      </h2>
      <p>
        {{ t("justopp.aboutSection.firstParagraph") }}
      </p>
      <p>
        {{ t("justopp.aboutSection.secondParagraph") }}
      </p>
      <p>
        {{ t("justopp.aboutSection.thirdParagraph") }}
      </p>
    </div>
  </div>
  <div class="spacer bg-lead c-bg padding-xl-top">
    <icon
      class="cursor-pointer"
      icon="arrow-white"
      @click="scrollToElement('#top-categories-section')" />
  </div>
</template>

<script>
import scrollToElementMixin from "@/client/applications/justopp/extensions/mixins/scrollToElement.js";

export default {
  name: "AboutSection",
  mixins: [scrollToElementMixin],
};
</script>

<style lang="scss" scoped>
#about-section {
  h2 {
    font-weight: bold;
  }
}

.desktop-padding-top {
  @media (min-width: 1024px) {
    padding-top: var(--margin-max) !important;
  }
}

.spacer {
  text-align: center;
  height: 50px;
  padding-bottom: var(--margin-2xl);

  i {
    flex: 1 !important;
    height: 16px !important;
    width: 26px !important;
  }

  @media (min-width: 1024px) {
    height: 80px;

    i {
      height: 25px !important;
      width: 41px !important;
    }
  }
}
</style>
